import React from "react";
import CookieConsent from "./src/components/Cookie-consent/cookie-consent";
import WebMcp from "./src/components/WebMcp/web-mcp";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieConsent />
    <WebMcp />
  </>
);
